import type { LevelId } from '@ezishizi/content-schema';

/**
 * The highest lesson any island format or in-game difficulty ramp bands from — reaching it opens
 * every ladder and every ramp sits at its hardest step. Kept in its own module (rather than
 * derived from `islands.ts`'s `UNLOCKED_FROM`) so `games.ts`'s in-game ramps (`match_pairs` pair
 * count, `tone_paint`'s arrows→trace→blind, Bridge's plank count) can use it without an import
 * cycle through `islands.ts`, which itself imports from `games.ts`. `islands.test.ts` checks this
 * against `UNLOCKED_FROM` directly, so the two cannot drift silently.
 */
export const MAX_BAND = 8;

/**
 * The lesson order island formats and in-game ramps should band against, for a lesson in a given
 * level. Both climb across P1's own 19 lessons (a P1 child has never met these formats or played
 * at these difficulties); a P2–P6 child has already finished P1 and everything it unlocks, so
 * banding, say, P2a-l01 at lesson-order 1 would hand it the same beginner ramp all over again.
 * Every level but P1 is treated as already at the end of that ramp: every format opens, and every
 * ramp sits at its hardest step, from that level's own lesson 1. P1 is unaffected — this returns
 * `lessonOrder` unchanged.
 */
export function effectiveLessonOrder(levelId: LevelId, lessonOrder: number): number {
  return levelId === 'p1' ? lessonOrder : Math.max(lessonOrder, MAX_BAND);
}
